module.exports = __webpack_public_path__ + "static/nlmk-31142eb6de737fe0dcde31c5d251a36a.jpg";